var id, region, results, selectedLocation;

$(document).ready(function() {
    initializeFoundation();
});

function initializeFoundation() {
    $(document).foundation();
    console.log('Foundation reinitialized');
}

$('body').on('hide.zf.dropdown', function(event, elem) {
    // reset everything so it's ready for the next time the user clicks on the button
    if (checkString(elem[0].getAttribute('class'),'consultant-cta__form')) {
        $('.step-one').removeClass('hide');
        $('.consultant-region').removeClass('hide');
        $('.consultant-state').addClass('hide');
        initializeFoundation();
    }
});

$('.consultant-region').on('click', function(e) {
    $('.step-four').addClass('hide');
    $('.confirmation-message').addClass('hide');
    region = $(this).data('region');
    if ($(this).data('children') === 'hasChildren') {
        $('.consultant-region').addClass('hide');
        $('.back-to-region').removeClass('hide');
        $('.consultant-state[data-region=' + region + ']').removeClass('hide');
    } else {
        // no children to display so skip right to the form
        getConsultants(region);

        $('.step-three').removeClass('hide');

        if ($('.consultant-banner-content').length) {
            selectedLocation = $(this).text();
        } else {
            $('.consultant-region').addClass('hide');
            $('.step-one').addClass('hide');
        }

        // if we're using the banner, display it and the selected region
        showBannerContents();
    }
});

$('.back-to-region').on('click', function(e) {
    $('.consultant-region').removeClass('hide');
    $('.consultant-state').addClass('hide');
    $('.back-to-region').addClass('hide');
});

$('.consultant-state').on('click', function() {
    console.log('State clicked');
    $('.step-four').addClass('hide');
    id = $(this).data('state');
    getConsultants(id);

    $('.step-three').removeClass('hide');
    selectedLocation = $(this).text().trim();
    
    // Close the dropdown and show modal
    var $modal = $('.reveal');
    $modal.css({
        "display": "flex",
        "flex-direction": "column",
        "align-items": "center",
        "text-align": "center"
    }).hide().fadeIn();
    $modal.foundation('open');
    $('.consultant-cta__selected-location').text(selectedLocation);
});

$('#findAConsultant').on('submit', function() {
    var email = $('#emailAddress').val();
    $('input#emailAddressCopy').val(email);
});

var consultantForm = document.getElementById('findAConsultant');
consultantForm.addEventListener('form.submit.success', function(event) {
    $('.step-three').addClass('hide');
    $('.step-four').removeClass('hide');
});
$('#contactAConsultant').on('submit', function() {
    $('.step-five').addClass('hide');
    $('.confirmation-message').removeClass('hide');
});

$('#skipForm').on('click', function(e) {
    e.preventDefault();
    $('.step-three').addClass('hide');
    $('.step-four').removeClass('hide');
    $('.step-five').addClass('hide');
});

$('.consultant-banner-content .close-button').on('click', function(){
    var $modal = $('.reveal');
    $modal.foundation('close');
    $modal.hide();
    
    // Cleanup
    $('.reveal-overlay').remove();
    $('body').removeClass('is-reveal-open');
    $('.consultant-cta__selected-location').text('');
    
    // Reset dropdown state
    $('.step-one').removeClass('hide');
    $('.consultant-region').removeClass('hide');
    $('.consultant-state').addClass('hide');
    
    // Reinitialize Foundation
    initializeFoundation();
});

function showBannerContents() {
    var $consultantBanner = $('.consultant-banner-content');

    if ($consultantBanner.length) {

        // on consultant page
        // show banner contents
        $consultantBanner.find('#formBanner').css("display", "flex").hide().fadeIn();
        $('.consultant-banner-cta .consultant-cta__form.dropdown-pane').removeClass('is-open');

        // show selected location
        // console.log(selectedLocation);
        $('.consultant-cta__selected-location').text(selectedLocation);
    } else {

      // not on consultant page
      $('#consultant-cta__form-large').foundation('close');
    }
    $('.consultant-banner-content #formBanner').show();
}

function getConsultants(id) {
    $('.default.consultant-detail').hide();
    $('.consultant-results').html('');
    $.ajax({
        url: '/consultants.json',
        dataType: 'json',
        data: {
            region: id,
        },
    })
        .done(function(data) {
          results = data.data;

          if (results.length > 0) {
              for (var x = 0; x < results.length; x++) {
                  //if Matt's silly email is this
                  //then hide the email and show his name
                //   if (results[x].email === "softail87@nuveramail.net") {
                //     $('.consultant-results').append(
                //         '<div class="consultant-detail">' +
                //           results[x].title + '<br />' +
                //           (results[x].streetAddress
                //             ? results[x].streetAddress + '<br />'
                //             : '' ) +
                //           (results[x].cityStateZip
                //             ? results[x].cityStateZip + '<br />'
                //             : '') +
                //           (results[x].phone
                //             ? '<br />Tel: <a href="tel:' + results[x].phone + '">' + results[x].phone + '</a>'
                //             : '') +
                //           (results[x].fax
                //             ? '<br />Fax: <a href="tel:' + results[x].fax + '">' + results[x].fax + '</a>'
                //             : '') +
                //           (results[x].email
                //             ? '<br />Contact: <a href="mailto:' + results[x].email + '">' + "Matt Finnegan"  + '</a>'
                //             : '') +
  
                //           (results[x].website && !checkString(results[x].website,'playcraft')
                //             ? '<br />Website: <a href="' + results[x].website + '" target="_blank">' + results[x].website + '</a>'
                //             : '') +
                //         '<br /><br /></div>'
                //     );
                //   } 
                
                  $('.consultant-results').append(
                      '<div class="consultant-detail">' +
                        results[x].title + '<br />' +
                        (results[x].streetAddress
                          ? results[x].streetAddress + '<br />'
                          : '' ) +
                        (results[x].cityStateZip
                          ? results[x].cityStateZip + '<br />'
                          : '') +
                        (results[x].phone
                          ? '<br />Tel: <a href="tel:' + results[x].phone + '">' + results[x].phone + '</a>'
                          : '') +
                        (results[x].fax
                          ? '<br />Fax: <a href="tel:' + results[x].fax + '">' + results[x].fax + '</a>'
                          : '') +
                        (results[x].email
                          ? '<br />Contact: <a href="mailto:' + results[x].email + '">' + results[x].email  + '</a>'
                          : '') +

                        (results[x].website && !checkString(results[x].website,'playcraft')
                          ? '<br />Website: <a href="' + results[x].website + '" target="_blank">' + results[x].website + '</a>'
                          : '') +
                      '<br /><br /></div>'
                  );
              }
            } else {
                $('.default.consultant-detail').show();
            }
        })
        .fail(function(data, msg) {
            $('.default.consultant-detail').show();
            console.log(msg);
        });
}

function checkString(str,sub) {
  return (str.indexOf(sub) !== -1);
}